var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"backdrop"},[_c('div',{staticClass:"uploader"},[_c('div',[_vm._v(_vm._s(_vm.$i18nPresenter.t('Uploading...')))]),_c('div',{staticClass:"text-center"},[_c('Loader')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }